import { CartItemType } from "src/types/cart/CartItem";
import apiSlice from "../apiSlice";


const cartApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        cartSync: build.mutation({
            query: (items: CartItemType[]) => ({
                url: "/carts/sync/",
                method: "POST",
                body: { items },
            }),

        }),
        cartAction: build.mutation({
            query: (action: {
                action: "add" | "remove" | "reset" | "update";
                slug?: string,
                qty?: number
            }) => {
                return {
                    url: "/carts/action/",
                    method: "POST",
                    body: action
                }
            }
        })
    })
})


export const { useCartSyncMutation, useCartActionMutation } = cartApiSlice;